import { useI18n } from 'vue-i18n';

// O que o agente fez com cada foto e PDF de um turno de teste (o `attachments` do resultado,
// L-19 e L-23): o motivo de não ter lido, na língua da tela. São dois lugares a mostrar — o rastro
// do turno (`RastroDoTurno`, no Playground e no bloco do link de teste) e a frase embaixo da
// resposta, para a equipe (`ConversaDeTeste`) — e uma leitura só. Os textos são da conversa
// (`CONVERSA_DE_TESTE`), que o painel também tem. Motivo que a tela não conhece aparece como veio.
export function useMotivoDoArquivo() {
  const { t } = useI18n();
  return motivo => {
    const motivos = {
      nao_analisado: t('CONVERSA_DE_TESTE.FILES.REASONS.NAO_ANALISADO'),
      ilegivel: t('CONVERSA_DE_TESTE.FILES.REASONS.ILEGIVEL'),
      excedente: t('CONVERSA_DE_TESTE.FILES.REASONS.EXCEDENTE'),
      nao_baixou: t('CONVERSA_DE_TESTE.FILES.REASONS.NAO_BAIXOU'),
      audio: t('CONVERSA_DE_TESTE.FILES.REASONS.AUDIO'),
      janela_de_manutencao: t(
        'CONVERSA_DE_TESTE.FILES.REASONS.JANELA_DE_MANUTENCAO'
      ),
    };
    return motivos[motivo] || motivo;
  };
}
